import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";
import { RelatedItemCard } from "@/pages/dashboard/shared/RelatedItemCard";
import { SupportedLocale } from "@/i18n";
import { useCallback, useState } from "react";
import { RelatedFieldsWithAttachments } from "../types";

interface RelatedWorksAccordionProps {
  relatedFieldsWithAttachments: RelatedFieldsWithAttachments;
  relationNotEmpty: boolean;
  locale: SupportedLocale;
  t: (key: string) => string;
}

export function RelatedWorksAccordion({
  relatedFieldsWithAttachments,
  relationNotEmpty,
  locale,
  t,
}: RelatedWorksAccordionProps) {
  const [expandedDocs, setExpandedDocs] = useState<Record<string, boolean>>({});

  const handleToggleExpand = useCallback((id: string) => {
    setExpandedDocs((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  }, []);

  if (!relationNotEmpty) return null;

  const fields = relatedFieldsWithAttachments;

  return (
    <AccordionItem value="oeuvres">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleArtworkSubtitleAssociatedWorks")}
      </AccordionTrigger>
      <AccordionContent className="flex flex-col gap-4 w-full">
        {fields?.relatedArtwork?.map((artwork: any) => (
          <RelatedItemCard
            key={artwork.id}
            item={artwork}
            type="artwork"
            locale={locale}
            expandedDocs={expandedDocs}
            onToggleExpand={handleToggleExpand}
            t={t}
          />
        ))}
        {fields?.from_Artwork_relatedArtwork?.map((artwork: any) => (
          <RelatedItemCard
            key={artwork.id}
            item={artwork}
            type="artwork"
            locale={locale}
            expandedDocs={expandedDocs}
            onToggleExpand={handleToggleExpand}
            t={t}
          />
        ))}
        {fields?.relatedDocument?.map((document: any) => (
          <RelatedItemCard
            key={document.id}
            item={document}
            type="document"
            locale={locale}
            expandedDocs={expandedDocs}
            onToggleExpand={handleToggleExpand}
            t={t}
          />
        ))}
        {fields?.relatedMultipleprint?.map((multipleprint: any) => (
          <RelatedItemCard
            key={multipleprint.id}
            item={multipleprint}
            type="multipleprint"
            locale={locale}
            expandedDocs={expandedDocs}
            onToggleExpand={handleToggleExpand}
            t={t}
          />
        ))}
        {fields?.relatedPhotography?.map((photography: any) => (
          <RelatedItemCard
            key={photography.id}
            item={photography}
            type="photography"
            locale={locale}
            expandedDocs={expandedDocs}
            onToggleExpand={handleToggleExpand}
            t={t}
          />
        ))}
        {fields?.relatedWriting?.map((writing: any) => (
          <RelatedItemCard
            key={writing.id}
            item={writing}
            type="writing"
            locale={locale}
            expandedDocs={expandedDocs}
            onToggleExpand={handleToggleExpand}
            t={t}
          />
        ))}
        {fields?.relatedAudiovisual?.map((audiovisual: any) => (
          <RelatedItemCard
            key={audiovisual.id}
            item={audiovisual}
            type="audiovisual"
            locale={locale}
            expandedDocs={expandedDocs}
            onToggleExpand={handleToggleExpand}
            t={t}
          />
        ))}
      </AccordionContent>
    </AccordionItem>
  );
}
